import React from 'react';
import '../../css/vers2/PickupContactSection.css';

type PickupContactSectionProps = {
    setPage: React.Dispatch<React.SetStateAction<string>>;
};

const HangingLetters = () => (
    <div className="hanging-letters">
        <img className="hanging-letter letter-a" src="/icons/halen_brengen/A.png" alt="" />
        <img className="hanging-letter letter-b" src="/icons/halen_brengen/B.png" alt="" />
        <img className="hanging-letter letter-c" src="/icons/halen_brengen/C.png" alt="" />
    </div>
);

const PickupContactSection = ({ setPage }: PickupContactSectionProps) => {
    return (
        <section id="halen" className="pickup-scene white-pattern">
            <img className="pickup-stars stars-top-left" src="/icons/halen_brengen/stars.png" alt="" />
            <img className="pickup-stars stars-top-right" src="/icons/halen_brengen/stars.png" alt="" />
            <img className="pickup-stars stars-bottom" src="/icons/halen_brengen/stars.png" alt="" />

            <HangingLetters />

            <div className="pickup-badge badge-purple">
                <img src="/icons/halen_brengen/purpleTextvak.png" alt="" />
                <span>Halen &amp;<br />Brengen</span>
            </div>

            <div className="pickup-text pickup-text-left">
                <p>
                    Mocht u door omstandigheden uw kind niet op tijd kunnen ophalen, neemt u dan contact met mij op.
                    Het is in de meeste gevallen geen probleem als u uw kind later ophaalt.
                </p>
                <p>
                    Indien uw kind door iemand anders opgehaald wordt, dient u dit op tijd te melden.
                    Indien dit niet van te voren doorgegeven is, wordt er altijd contact met u opgenomen.
                </p>
                <p>
                    Is het nodig dat uw kind langer moet blijven, dan is het fijn als dit van te voren overlegd wordt.
                    Dit i.v.m de planning van de dag.
                </p>
            </div>

            <div className="pickup-badge badge-blue">
                <img src="/icons/halen_brengen/blueTextvak.png" alt="" />
                <span>Contact &amp;<br />Aansprakelijkheid</span>
            </div>

            <div className="pickup-text pickup-text-right" id="contact">
                <h3>Contact met ouders</h3>
                <p>
                    Gedurende de opvang staat het altijd vrij, even contact op te nemen om te vragen hoe het met uw
                    kind gaat.
                </p>

                <h3>Aansprakelijkheid</h3>
                <p>
                    De gastouder kan op geen enkele manier aansprakelijk worden gesteld, voor beschadiging of
                    vermissing van goederen die door de vraagouder aan het kind meegegeven wordt naar de opvang.
                </p>
                <p>De gastouder heeft een zakelijk W.A. verzekering.</p>
            </div>
        </section>
    );
};

export default PickupContactSection;
